(() => {
  if (window.VesanbeTestimonialCarousel) {
    window.VesanbeTestimonialCarousel.init();
    return;
  }

  const api = {
    init(container = document) {
      const roots = [];

      if (
        container.matches &&
        container.matches('[data-testimonial-carousel]')
      ) {
        roots.push(container);
      }

      if (container.querySelectorAll) {
        roots.push(
          ...container.querySelectorAll('[data-testimonial-carousel]')
        );
      }

      [...new Set(roots)].forEach((root) => {
        if (root.dataset.testimonialReady === 'true') return;

        root.dataset.testimonialReady = 'true';

        const slides = Array.from(
          root.querySelectorAll('[data-testimonial-slide]')
        );

        if (slides.length < 2) return;

        const previousButton = root.querySelector('[data-testimonial-prev]');
        const nextButton = root.querySelector('[data-testimonial-next]');

        let currentIndex = slides.findIndex((slide) =>
          slide.classList.contains('is-active')
        );

        if (currentIndex < 0) currentIndex = 0;

        const showSlide = (nextIndex) => {
          currentIndex = (nextIndex + slides.length) % slides.length;

          slides.forEach((slide, index) => {
            const isActive = index === currentIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );
          });
        };

        if (previousButton) {
          previousButton.addEventListener('click', () => {
            showSlide(currentIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            showSlide(currentIndex + 1);
          });
        }

        root.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showSlide(currentIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showSlide(currentIndex + 1);
          }
        });
      });
    }
  };

  window.VesanbeTestimonialCarousel = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      api.init();
    });
  } else {
    api.init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    api.init(event.target);
  });
})();
